import { Controller } from "react-hook-form";
import {
  AdditionalFormFieldProps,
  AutocompleteFieldProps,
} from "../common-types";
import { Autocomplete, TextField, Typography } from "@mui/material";
import { TextFieldStyle } from "../text-input-field/text-input-field.style";



const AutocompleteFormField: React.FC<
  AutocompleteFieldProps & AdditionalFormFieldProps
> = (props) => {
  const {
    name,
    defaultValue,
    control,
    options,
    className,
    label,
    placeholder,
    helperText,
    disabled,
    onSelect,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          disablePortal
          value={value || ""}
          options={options}
          onChange={onSelect}
          renderInput={(params) => (
            <TextFieldStyle className={`${className || ""} field-wrapper`}>
              {label && (
                <Typography className="field-label">{label}</Typography>
              )}
              <TextField
                {...params}
                sx={{ width: "100%" }}
                id={name}
                placeholder={placeholder}
                helperText={error?.message || helperText || null}
                autoComplete="off"
                disabled={disabled}
                onChange={onChange}
                error={!!error}
              />
            </TextFieldStyle>
          )}
        />
      )}
    />
  );
};

export default AutocompleteFormField;
